import { SearchableDropdownItem } from 'components/SearchableDropdown/constants';
export interface IFiltersProps {
    bodyColor: string;
    filterSource: SearchableDropdownItem|undefined;
    filterRating: SearchableDropdownItem|undefined;
    orderBy: SearchableDropdownItem|undefined;
    keyWords: string[];
    setFilterSource: any;
    setFilterRating: any;
    setOrderBy: any;
    setKeyWords: any;
    selectedTab: string;
    handleEditProviders: any;
    handleEditRatings: any;
    sourceList: SearchableDropdownItem[];
    ratingsList: SearchableDropdownItem[];
    editRatingsList: boolean;
}

export const OrderByValues: SearchableDropdownItem[] = [
    { id: '00', displayName: 'Highest to lowest rating' },
    { id: '01', displayName: 'Lowest to Highest rating' },
    { id: '02', displayName: 'Most Recent' },
    { id: '03', displayName: 'Oldest to newest' },
];

export const orderByValuesSend: any[] = [
    { id: '00', orderby: 'c.rating DESC' },
    { id: '01', orderby: 'c.rating ASC' },
    { id: '02', orderby: 'c.date DESC' },
    { id: '03', orderby: 'c.date ASC' },
];

export const FacebookRecommended: SearchableDropdownItem[] = [
    { id: '0', displayName: 'All'},
    { id: '1', displayName: 'Recommended'},
    { id: '2', displayName: 'Not Recommended'},
];